import React from 'react';
import {
  Container,
  Image,
  Text,
} from './styles';

const AwaitingApproval = () => (
  <Container>
    <Image src="/images/await-approval-user.png" />
    <Text>
      Thanks for signing up!
      To protect your team’s privacy, the workspace administrator must approve you before you can launch studies.
    </Text>
  </Container>
);

export default AwaitingApproval;
